import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/ico_gib.svg")